// UserLevelBadge.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { TranslationNamespace } from '../resource/translationNamespace.js';

import CrownIconSource from '../../img/ic_channel_vip.svg';

export const UserLevelBadge = ({
  t,
  height,
  fontSize,
  levelNameFontSize,
  shouldDirectToInfomation,
  directToInfomation,
  shouldDisplayLevelName,
  level,
}) => {
  if (!level) return null;
  return (
    <StyledUserLevelBadge isLink={shouldDirectToInfomation}>
      <Badge
        height={height}
        fontSize={fontSize}
        onClick={() => {
          if (shouldDirectToInfomation) directToInfomation();
        }}
      >
        <CrownIcon src={CrownIconSource} alt="user level" />
        <Level fontSize={fontSize}>{`L${level}`}</Level>
      </Badge>
      {shouldDisplayLevelName && (
        <LevelName levelNameFontSize={levelNameFontSize}>
          {t(`vip_level_${level}`, {
            ns: TranslationNamespace.LIVESTREAM,
          })}
        </LevelName>
      )}
    </StyledUserLevelBadge>
  );
};

UserLevelBadge.propTypes = {
  t: PropTypes.func.isRequired,
  height: PropTypes.number,
  fontSize: PropTypes.number,
  levelNameFontSize: PropTypes.number,
  level: PropTypes.number,
  shouldDisplayLevelName: PropTypes.bool,
  shouldDirectToInfomation: PropTypes.bool,
  directToInfomation: PropTypes.func,
};

UserLevelBadge.defaultProps = {
  height: 14,
  fontSize: 10,
  levelNameFontSize: 14,
  level: null,
  shouldDisplayLevelName: false,
  shouldDirectToInfomation: false,
  directToInfomation: () => null,
};

const StyledUserLevelBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ isLink }) => (isLink ? 'pointer' : 'auto')};
`;

const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  color: #ffffff;
  padding: 4px 4px 4px 2px;
  border-radius: 7px;
  background-color: #c18a28;
  height: ${({ height }) => `${height}px`};
  font-size: ${({ fontSize }) => `${fontSize}px`};
`;

const CrownIcon = styled.img`
  width: 16px;
  height: 16px;
`;

const Level = styled.span`
  /* designer insist to font-size: 10px */
  transform: ${({ fontSize }) => `scale(${fontSize < 12 ? 0.8 : 1})`};
`;

const LevelName = styled.span`
  margin-left: 8px;
  font-size: ${({ levelNameFontSize }) => `${levelNameFontSize}px`};
`;

export default withTranslation()(UserLevelBadge);
